const host = window.location.host;
let baseUrl = ''
if (host==='www.hit-cloud.net'){
    baseUrl='https://demo.pzjdimg.com'
}else if(host==='www.hit-cloud.cn'){
    baseUrl='https://www.pzjdimg.com'
}else{
    baseUrl='https://demo.pzjdimg.com'
}

export default {
    baseUrl
};
